import {isFeatureEnabled} from '@github-ui/feature-flags'
import {session} from '@github/turbo'

interface ProgressBar {
  setValue(n: number): void
  hide(): void
  show(): void
}

export interface BrowserAdapter {
  progressBar: ProgressBar
}

const adapter = session.adapter as typeof session.adapter & BrowserAdapter

let progressBarDelay: ReturnType<typeof setTimeout> | null = null

// Start the ProgressBar at the top of the page.
export const beginProgressBar = () => {
  const delay = getProgressBarDelay()

  progressBarDelay = setTimeout(() => {
    adapter.progressBar.setValue(0)
    adapter.progressBar.show()
  }, delay)
}

// Complete the ProgressBar at the top of the page.
export const completeProgressBar = () => {
  if (progressBarDelay !== null) {
    clearTimeout(progressBarDelay)
    progressBarDelay = null
  }
  adapter.progressBar.setValue(1)
  adapter.progressBar.hide()
}

function getProgressBarDelay() {
  if (isFeatureEnabled('progress_bar_delay_50')) return 50
  if (isFeatureEnabled('progress_bar_delay_99')) return 99
  if (isFeatureEnabled('progress_bar_delay_500')) return 500
  return 0
}
